function taskArchivedBadge () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/task-archived-badge/task-archived-badge-directive.html?$$REVISION$$'
  }
}

export { taskArchivedBadge }
